<template>
<svg :width="size" :height="size" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.66602 13.8063L3.99935 15.1397L5.33268 13.8063L6.67268 15.1397L8.00602 13.8063L9.33935 15.1397L10.6793 13.8063L12.0127 15.1397L13.346 13.8063V13.6797V1.33301H2.66602V13.6797V13.8063Z" stroke="#727D94" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.5 6L7.0625 9.33333L5.5 7.81818" stroke="#727D94" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>

<script>
export default {
    props:{
        size:{
            default: '16'
        },
    }
}
</script>


<style>

</style>

